export default "__VITE_ASSET__9uqRwZHy__"